export const version = '0.761.1'
export const chameleonWebVersion = '9.0.1'
export const chameleonCoreVersion = '7.6.0'
